import styled, { FlattenSimpleInterpolation } from 'styled-components';

// Import styles
import { generateResponsiveGrid } from 'components/styles';

// Import types
import { FormGridConfig } from 'types/views/form';

type WrapperProps = { gridConfig?: FormGridConfig; customStyles?: FlattenSimpleInterpolation };

export const Wrapper = styled.div`
	width: 100%;
	display: grid;
	column-gap: 2rem;
	grid-template-columns: repeat(16, 1fr);
`;

export const FieldWrapper = styled.div<WrapperProps>`
	min-height: 8rem;
	grid-column: auto;

	${({ gridConfig, customStyles }) => generateResponsiveGrid(gridConfig, customStyles)};
`;
